import { translate } from "utils/string-table";

export const computeInitialGradeSelected = (validList: string[], initialSelection: string[]) => {
  const isValid = initialSelection.every((item) => validList.includes(item));
  return isValid ? initialSelection : [translate("UNKNOWN")];
};
